import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import DateFilter from '../common/dateFilter';
import strings from '../locales/';

const Header = props =>
  !props.loadingFilter ? (
    <div className="header">
      {props.filter.map((item, i) =>
        (item.name && props.flowRequestCategory!=null 
          && item.name.toUpperCase()==props.flowRequestCategory.toUpperCase()) ? (
          <div key={`box-filter-${i}`} className="box-form islabel box170">
            <div>
              <label>{props.language[item.name.toLowerCase()]}</label>
            </div>
            <div>
              <Autocomplete
                value={
                  props.filters.tags.length > 0 && props.filters.tags[i] != ''
                    ? props.filters.tags[i]
                    : 'TODOS'
                }
                save={'TODOS'}
                id={`au-${i}`}
                alias="tag"
                select="tag"
                idItem="id"
                filter={item.tags}
                handleSubmit={props.handleSubmit}
              />
            </div>
          </div>
        ) : (null))}
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.from}</label>
        </div>
        <div>
          <DateFilter
            date={props.filters.date.fechaStartFinal ? 
              props.filters.date.fechaStartFinal : props.datos.fromDate.substring(0, 10)}
            dif={0}
            id="date-start"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.to}</label>
        </div>
        <div>
          <DateFilter
            date={props.filters.date.fechaEndFinal ? 
              props.filters.date.fechaEndFinal : props.datos.toDate.substring(0, 10)}
            dif={0}
            id="date-end"
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="header" />
  );

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_rca_reports/header.jsx